module.exports = __webpack_public_path__ + "img/prize-06.d166e0fb.png";